module.exports = __webpack_public_path__ + "static/media/400126_02.6d81a8dd.png";